import * as React from "react";
import "debounce";
import "tabbable";
import { useIsMounted } from "../../helpers/helper/hooks/use-is-mounted.mjs";
import { Tooltip } from "../../tooltip/tooltip.mjs";
const defaultColors = [
  "var(--color-chart-1)",
  "var(--color-chart-2)",
  "var(--color-chart-3)",
  "var(--color-chart-4)",
  "var(--color-chart-5)",
  "var(--color-chart-6)",
  "var(--color-chart-7)"
];
const ChartBarHorizontal = (props) => {
  const { title, className, value, color = defaultColors, renderTooltipContent, renderGroupedTooltipContent } = props;
  const [width, setWidth] = React.useState(0);
  const isMounted = useIsMounted();
  const BEM = () => {
    const classArray = ["chart-bar-horizontal"];
    if (className) {
      classArray.push(className);
    }
    return classArray.join(" ");
  };
  const getTitle = (title2) => {
    return /* @__PURE__ */ React.createElement("div", { className: "chart-bar-horizontal__title" }, title2);
  };
  const memoizedDataArray = React.useMemo(() => {
    const colorArray = Array.isArray(color) ? color : [color];
    let shiftToRight = 0;
    const dataArray = [];
    if (Array.isArray(value)) {
      value.forEach((singleValue, index) => {
        dataArray.push({
          color: colorArray[index],
          value: singleValue,
          left: shiftToRight
        });
        shiftToRight += singleValue.value;
      });
    } else {
      dataArray.push({
        color: colorArray[0],
        value,
        left: 0
      });
    }
    return dataArray;
  }, [color, value]);
  const getValueBarStyles = (value2, color2, left) => {
    return {
      background: color2,
      width: "".concat(value2, "%"),
      left: "".concat(left, "%")
    };
  };
  const getTooltipContent = (currentBar) => {
    if (!renderTooltipContent) {
      return null;
    } else if (typeof currentBar.value !== "number") {
      const tooltipProps = getTooltipSettings();
      return /* @__PURE__ */ React.createElement(Tooltip, { ...tooltipProps, referenceElement: "#".concat(currentBar.value.id) }, renderTooltipContent(currentBar));
    }
  };
  const getGroupedTooltipContent = () => {
    if (!renderGroupedTooltipContent || typeof value === "number") {
      return null;
    } else {
      const tooltipProps = getTooltipSettings();
      return /* @__PURE__ */ React.createElement(Tooltip, { ...tooltipProps, referenceElement: "#".concat(getGroupedBarElementId()) }, renderGroupedTooltipContent(memoizedDataArray));
    }
  };
  const getTooltipSettings = () => {
    const placement = "top";
    return {
      placement
    };
  };
  React.useEffect(() => {
    let barWidth;
    if (Array.isArray(value)) {
      const chartBarValuesSum = value.map((item) => item.value).reduce((total, value2) => total + value2);
      barWidth = chartBarValuesSum;
    } else if (typeof value === "number") {
      barWidth = value;
    } else {
      barWidth = value.value;
    }
    if (isMounted) {
      setWidth(barWidth);
    }
  }, [setWidth, isMounted, value]);
  const getGroupedBarElementId = () => {
    if (Array.isArray(value)) {
      return "chart-bar-".concat(value[0].id);
    } else if (typeof value !== "number") {
      return "chart-bar-".concat(value.id);
    }
  };
  const BarElement = renderTooltipContent ? "button" : "span";
  const GroupedBarElement = renderGroupedTooltipContent ? "button" : "div";
  return /* @__PURE__ */ React.createElement("div", { className: BEM() }, title && getTitle(title), /* @__PURE__ */ React.createElement(GroupedBarElement, { className: "chart-bar-horizontal__bar-wrapper", type: renderGroupedTooltipContent ? "button" : void 0, id: getGroupedBarElementId() }, memoizedDataArray.map((data, index) => /* @__PURE__ */ React.createElement(React.Fragment, { key: index }, /* @__PURE__ */ React.createElement(
    BarElement,
    {
      key: index,
      className: "chart-bar-horizontal__value-bar",
      type: renderTooltipContent ? "button" : void 0,
      style: getValueBarStyles(typeof data.value === "number" ? data.value : data.value.value, data.color, data.left),
      id: typeof data.value === "number" ? void 0 : data.value.id
    },
    /* @__PURE__ */ React.createElement("span", { className: "sr-only" }, typeof data.value === "number" ? data.value : data.value.value)
  ), getTooltipContent(data))), /* @__PURE__ */ React.createElement("span", { className: "chart-bar-horizontal__bar", style: { left: width + "%" } })), getGroupedTooltipContent());
};
export {
  ChartBarHorizontal
};
